import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AdminModule } from './modules/admin/admin.module';



@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    NgxSpinnerModule,
    AdminModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'vibetexCedae';
  isSidebarClosed: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Normalize stored sidebar state and initialize
    const savedState = localStorage.getItem('sidebarState');
    // The app historically used both 'sidebar-closed' and 'closed' values.
    this.isSidebarClosed = savedState === 'sidebar-closed' || savedState === 'closed';
    // Ensure body gets the class for other global styles/components that rely on it
    this.updateBodySidebarClass();

    if (!localStorage.getItem('usuario')) {
      this.authService.logout();
      this.router.navigate(['/pages/usuarios/autenticar']);
    }
    const usuarioStorage = localStorage.getItem('usuario');
    if (usuarioStorage) {
      const usuario = JSON.parse(usuarioStorage);
      const usuarioId = usuario?.usuarioId;
      const role = usuario?.role?.toLowerCase() || usuario?.usuario?.role?.toLowerCase();

    }
  }
  
  toggleSidebar(): void {
    this.isSidebarClosed = !this.isSidebarClosed;
    // keep a stable canonical value
    localStorage.setItem('sidebarState', this.isSidebarClosed ? 'sidebar-closed' : 'sidebar-open');
    this.updateBodySidebarClass();
    // Dispatch a custom event so other components (ex: maps) can react to the layout change
    try {
      const event = new CustomEvent('sidebarToggled', { detail: { closed: this.isSidebarClosed } });
      window.dispatchEvent(event);
    } catch (e) {
      // ignore if environment doesn't support CustomEvent
      try { window.dispatchEvent(new Event('sidebarToggled')); } catch (err) {}
    }
  }

  private updateBodySidebarClass(): void {
    try {
      if (this.isSidebarClosed) {
        document.body.classList.add('sidebar-closed');
      } else {
        document.body.classList.remove('sidebar-closed');
      }
    } catch (e) {
      // server-side rendering or restricted environment may not have document
    }
  }

  shouldShowMainContainer(): boolean {
    return this.isAuthenticated() && !this.router.url.includes('/pages/usuarios/autenticar');
  }

  isAuthenticated(): boolean {
    const isLogged = this.authService.isLoggedIn();
    if (!isLogged && !this.router.url.includes('/pages/usuarios/autenticar')) {
      this.router.navigate(['/pages/usuarios/autenticar']);
    }
    return isLogged;
  }
}
